import qrCodeAnimation from '@/shared/animations/qr-code.json';
import CloseIcon from '@/shared/icons/flip-ui-kit/large/Close';
import Lottie from '@/shared/utils/Lottie';

export const DepositChannelLoading = ({ onClose }: { onClose: () => void }) => (
  <div className="w-[487px]">
    <div className="flex flex-col items-center justify-center rounded-[6px] border border-cf-gray-4 bg-cf-gray-3 p-5">
      <CloseIcon onClick={onClose} className="cursor-pointer self-end" />
      <div className="mb-6 flex flex-col items-center gap-1">
        <Lottie as="div" animationData={qrCodeAnimation} autoplay loop className="h-44 w-44" />
        <span className="font-aeonikMedium text-14 text-cf-light-3">
          Opening deposit channel...
        </span>
      </div>
    </div>
  </div>
);
